<div class="wrapper" [ngClass]="notificationType">
  <p class="text"><ng-content></ng-content></p>
</div>
